import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Grid,
  Paper,
  ListItemIcon,
} from "@mui/material";
import TranslateIcon from "@mui/icons-material/Translate";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import PublicIcon from "@mui/icons-material/Public";
import ForumIcon from "@mui/icons-material/Forum";
import SignLanguageIcon from "@mui/icons-material/SignLanguage";
import LaunchIcon from "@mui/icons-material/Launch";

const features = [
  {
    icon: <RecordVoiceOverIcon fontSize="large" color="primary" />,
    primary: "ترجمه همزمان به گفتار و متن",
    secondary:
      "با استفاده از دوربین دستگاه، زبان اشاره شما را به صورت زنده به صدا و متن تبدیل می‌کند.",
  },
  {
    icon: <TranslateIcon fontSize="large" color="primary" />,
    primary: "مترجم دو طرفه",
    secondary:
      "کلمات و جملات را به زبان اشاره تصویری (آواتار) تبدیل کرده و ارتباطی کامل را ممکن می‌سازد.",
  },
  {
    icon: <PublicIcon fontSize="large" color="primary" />,
    primary: "پشتیبانی از زبان‌های مختلف",
    secondary: "پشتیبانی از زبان‌های اشاره مختلف از سراسر جهان.",
  },
  {
    icon: <ForumIcon fontSize="large" color="primary" />,
    primary: "انجمن و پشتیبانی",
    secondary:
      "در انجمن ما سوالات خود را بپرسید و با دیگران ارتباط برقرار کنید.",
  },
];

function SignTranslatorPage() {
  const handleRedirect = () => {
    window.open("https://panel.mmdtestserver1.ir/", "_blank");
  };

  return (
    <Box sx={{ direction: "rtl" }}>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          borderRadius: 2,
          border: "1px solid #ccc",
        }}
      >
        <SignLanguageIcon sx={{ fontSize: 60, color: "primary.main", mb: 2 }} />
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          textAlign="center"
          fontWeight="bold"
        >
          مترجم هوشمند زبان اشاره
        </Typography>
        <Typography
          variant="h6"
          color="text.secondary"
          textAlign="center"
          mb={4}
        >
          ارتباطی بدون مرز با اپلیکیشن جدید ما که پلی میان دنیای شنوا و ناشنوا
          ایجاد می‌کند.
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {features.map((feature) => (
            <Grid item xs={12} md={6} key={feature.primary}>
              <Card sx={{ height: "100%", borderRadius: 2 }}>
                <CardContent sx={{ textAlign: "center" }}>
                  <ListItemIcon
                    sx={{
                      justifyContent: "center",
                      minWidth: "auto",
                      mb: 1.5,
                    }}
                  >
                    {feature.icon}
                  </ListItemIcon>
                  <Typography variant="h6" component="div" fontWeight="medium">
                    {feature.primary}
                  </Typography>
                  <Typography sx={{ mt: 1 }} color="text.secondary">
                    {feature.secondary}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ mt: 5, width: "100%", textAlign: "center" }}>
          <Button
            variant="contained"
            size="large"
            startIcon={<LaunchIcon sx={{ ml: 1 }} />}
            onClick={handleRedirect}
            sx={{
              fontWeight: "bold",
              py: 1.5,
              px: 4,
              borderRadius: "12px",
            }}
          >
            ورود به اپلیکیشن
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}

export default SignTranslatorPage;
